export default __webpack_public_path__ + "8ad451f1322c361a34a693d114e9021a.svg";